
// ── NAV scroll effect ──
const nav = document.getElementById('mainNav');
window.addEventListener('scroll', () => {
  nav.classList.toggle('scrolled', window.scrollY > 60);
});

// ── Reveal on scroll ──
const reveals = document.querySelectorAll('.reveal');
const observer = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if(e.isIntersecting){
      e.target.classList.add('visible');
      // Stagger children
      e.target.querySelectorAll('.am,.tarifa-card,.stat,.ruta,.nat-place').forEach((el,i) => {
        el.style.transitionDelay = `${i*0.08}s`;
        el.classList.add('visible');
      });
    }
  });
}, {threshold:0.1, rootMargin:'0px 0px -40px 0px'});
reveals.forEach(el => observer.observe(el));

// ── CHATBOT ──
let chatOpen = false;
let sessionId = 'web_' + Math.random().toString(36).substr(2,9);
const WEBHOOK = 'https://rusticexpressions.app.n8n.cloud/webhook/website-chat'; // UPDATE WHEN READY

function toggleChat(){
  chatOpen = !chatOpen;
  document.getElementById('chatWindow').classList.toggle('open', chatOpen);
  document.querySelector('.chat-badge').style.display = chatOpen ? 'none' : 'block';
  if(chatOpen) document.getElementById('chatInput').focus();
}

function addMsg(text, role){
  const div = document.createElement('div');
  div.className = `msg ${role}`;
  div.textContent = text;
  const msgs = document.getElementById('chatMessages');
  msgs.appendChild(div);
  msgs.scrollTop = msgs.scrollHeight;
  return div;
}

function showTyping(){
  const div = document.createElement('div');
  div.className = 'msg typing';
  div.id = 'typing';
  div.innerHTML = '<div class="typing-dots"><span></span><span></span><span></span></div>';
  const msgs = document.getElementById('chatMessages');
  msgs.appendChild(div);
  msgs.scrollTop = msgs.scrollHeight;
}

function removeTyping(){
  const t = document.getElementById('typing');
  if(t) t.remove();
}

async function sendMessage(){
  const input = document.getElementById('chatInput');
  const text = input.value.trim();
  if(!text) return;
  input.value = '';
  addMsg(text, 'user');
  showTyping();

  try {
    const res = await fetch(WEBHOOK, {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({message:text, sessionId, platform:'website'})
    });
    const data = await res.json();
    removeTyping();
    const response = data.response || data.finalResponse || 'Hubo un problema, por favor intenta de nuevo.';
    addMsg(response, 'bot');
  } catch(e){
    removeTyping();
    addMsg('Por el momento hay un problema técnico. Contáctanos por WhatsApp al +52 614 000 0000', 'bot');
  }
}

// ── FORM ──
function submitForm(){
  const name = document.getElementById('f-name').value;
  const phone = document.getElementById('f-phone').value;
  const checkin = document.getElementById('f-checkin').value;
  const checkout = document.getElementById('f-checkout').value;
  const guests = document.getElementById('f-guests').value;
  const msg = document.getElementById('f-msg').value;

  if(!name||!phone||!checkin||!checkout||!guests){
    alert('Por favor completa todos los campos requeridos.');
    return;
  }

  const waMsg = encodeURIComponent(
    `Hola, soy ${name}. Me interesa reservar la Cabaña Cas D' Cristy.
` +
    `📅 Llegada: ${checkin} · Salida: ${checkout}
` +
    `👥 Grupo: ${guests}
` +
    `📱 Tel: ${phone}
` +
    (msg ? `💬 ${msg}` : '')
  );
  window.open(`https://wa.me/526140000000?text=${waMsg}`, '_blank');
}

// ── LIGHTBOX ──
function openLightbox(cell){
  const img = cell.querySelector('img');
  document.getElementById('lightboxImg').src = img.src;
  document.getElementById('lightbox').classList.add('open');
}
function closeLightbox(){
  document.getElementById('lightbox').classList.remove('open');
}
document.addEventListener('keydown', e => {
  if(e.key==='Escape') closeLightbox();
});
